export const LOAD_PERMISSIONS = 'customers/LOAD_PERMISSIONS';